import TransLog from './TransLog.vue';

export default TransLog;


// WEBPACK FOOTER //
// ./src/components/TransLog/index.js